/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Table_Page_Row_CountInputs */

const en_table_page_row_count = /** @type {(inputs: Table_Page_Row_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} row(s) on this page`)
};

const pt_br2_table_page_row_count = /** @type {(inputs: Table_Page_Row_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} linha(s) nesta página`)
};

/**
* | output |
* | --- |
* | "{count} row(s) on this page" |
*
* @param {Table_Page_Row_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_page_row_count = /** @type {((inputs: Table_Page_Row_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Page_Row_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_page_row_count(inputs)
	return pt_br2_table_page_row_count(inputs)
});